import { Button as AntButton, ButtonProps } from "antd";

const Button = (props: ButtonProps) => <AntButton {...props} />;

export default Button;
